/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import {
    GET_CAMPGROUND_RECREATION_SITES,
    GET_CAMPGROUND_RECREATION_SITES_ERROR,
} from '../constants';

const INITIALSTATE = {
    results: {},
};

export default function campground(state = INITIALSTATE, action) {
    const st = { ...state };

    switch (action.type) {
        case GET_CAMPGROUND_RECREATION_SITES:
            return { results: action.payload, isValid: true };
        case GET_CAMPGROUND_RECREATION_SITES_ERROR:
            return { error: action.error, results: [], isValid: false };
        default:
            return st;
    }
}
